export type Environment =
  | 'production'
  | 'staging'
  | 'sandbox'

function resolveEnvironmentFromUrl(url: URL): Environment {
    return (url.hostname.includes("localhost")) ? 'sandbox' : (url.hostname.includes('.staging.') ? 'staging' : 'production');
}

export function useEnvironment(): { environment: ComputedRef<Environment> } {
  const requestUrl = useRequestURL()

  const environment = computed<Environment>(() => resolveEnvironmentFromUrl(requestUrl));

  return { environment }
}
